import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import I18NextHttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const DIST_HASH = import.meta.env.VITE_CROWDIN_DIST_HASH;
const DIST_BASE_URL = import.meta.env.VITE_CROWDIN_CDN_BASE_URL;

const languageDetectionOptions = {
  order: ["cookie"],
  lookupCookie: "i18next",
  caches: ["cookie"],
  excludeCacheFor: ["cimode"],
};

i18next
  .use(LanguageDetector)
  .use(I18NextHttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    ns: ["coi-platform-translations", "languages-list"],
    defaultNS: "coi-platform-translations",
    backend: {
      loadPath: (lng: string, ns: string[]) => {
        if (ns.includes("languages-list")) {
          return `${DIST_BASE_URL}/${DIST_HASH}/content/en/{{ns}}.json`;
        }
        return `${DIST_BASE_URL}/${DIST_HASH}/content/{{lng}}/{{ns}}.json`;
      },
      requestOptions: {
        cache: "no-cache",
      },
    },
    interpolation: {
      escapeValue: false,
    },
    detection: languageDetectionOptions,
  });

export { i18next, languageDetectionOptions };
